module.exports = __webpack_public_path__ + "img/workFlowDoc.fa3143e1.png";